import type { CmsItem } from '~/types/cms';

export interface Link {
    url?: string | null;
    linkUrl?: string | null;
    linkText?: string | null;
    newWindow?: boolean | string | null;
    isEmpty?: boolean | null;
    isElement?: boolean | null;
    target?: string | null;
    title?: string | null;
    type?: string | null;
    element?: Element | null;
    customAttributes?: { [key: string]: string } | null;
}

export interface Element {
    id?: string | null;
    title?: string | null;
    slug?: string | null;
    sectionHandle?: string | null;
}

export const useConvertedButtonLink = (link: Link | CmsItem): string => {
    const localePath = useLocalePath();
    const query: { [key: string]: string } = {};

    if (link.type == 'verbb\\hyper\\links\\Email') return 'mailto:' + (link.linkUrl ?? '');
    if (link.type == 'verbb\\hyper\\links\\Phone') return 'tel:' + (link.linkUrl ?? '');

    if (
        ['verbb\\hyper\\links\\Entry', 'verbb\\hyper\\links\\Category'].includes(link.type) &&
        link.customAttributes != undefined &&
        !!Object.keys(link.customAttributes).length
    ) {
        for (const [key, value] of Object.entries(link.customAttributes)) {
            query[key] = String(value);
        }
    }

    if (link.type == 'verbb\\hyper\\links\\Entry' && link.element && link.element.slug && link.element.sectionHandle) {
        const slug = link.element.slug.split('/').filter(Boolean);
        const objList: Record<string, any> = {
            home: {
                name: 'index',
                query: query
            },
            pages: {
                name: 'slug',
                query: query,
                params: {
                    slug
                }
            },
            locations: useLocationRouteTarget(link.element as CmsItem),
            news: {
                name: 'news-slug',
                query: query,
                params: {
                    slug: link.element.slug
                }
            }
        };

        const targetRoute = objList[link.element.sectionHandle];
        if (targetRoute) {
            return localePath(targetRoute);
        }
    }

    return link.linkUrl ?? link.url ?? '';
};
